'use strict';

angular.module('app')

.run(function (Category) {}) // jshint ignore:line

.factory('Category', function (DS, Article) {
    return DS.defineResource({
        name: 'Category',
        endpoint: 'categories',
        upsert: true,
        relations: {
            hasMany: {
                Article: {
                    localField: 'articles',
                    foreignKey: 'category_id'
                }
            },
            belongsTo: {
                Programme: {
                    localField: 'programme',
                    localKey: 'programme_id'
                }
            }
        },
        methods: {
            getArticles: function ()
            {
                return Article.filter({
                    sort: 'display_order',
                    where: {
                        category_id: this.id,
                    }
                });
            }
        }
    });
});
